import styles from '@components/DevToolbar/DevToolbarComponent/DevToolbarComponent.styles';
import Icon from '@components/icons/Icon';
import { TIcon } from '@components/icons/typescript';
type PropsType = {
  icon: TIcon;
  color: string;
  isActive: boolean;
  isSpecial?: boolean;
  onClick?: () => void;
};
const DevToolbarComponent = ({
  icon,
  color,
  isActive,
  isSpecial = false,
  onClick = () => null
}: PropsType) => <div sx={styles.component(isSpecial, isActive)} onClick={onClick} onKeyDown={e => e.key === 'Enter' && onClick()} role="button" tabIndex={0}>
    <div sx={styles.componentIcon}>
      <Icon icon={icon} color={color} size="18px" />
    </div>
  </div>;
export default DevToolbarComponent;